export const SEARCH_INDEX = "SEARCH_INDEX";
export const SEARCH_BY_LOCATION = "SEARCH_BY_LOCATION";
export const SEARCH_BY_COMPANY = "SEARCH_BY_COMPANY";
export const SEARCH_BY_SKILLS = "SEARCH_BY_SKILLS";
export const SEARCH_BY_ALL = "SEARCH_BY_ALL";